export const manufacturerDefaultValues = {};
